import React from "react";
import { closeIcon } from "../../utils/images";

export default function ModalPopUp(props: {
    onclickhandler: () => void;
    children: React.ReactNode;
}) {
    return (
        <>
            <div
                className="modal bg-white fixed w-full h-screen top-0 left-0 flex items-center justify-center z-50"
                id="sarvSurakshaModal"
            >
                <div className="modal-overlay absolute w-full bg-gray-900 opacity-50"></div>
                <div className="modal-container bg-white w-full mx-auto z-50 overflow-y-auto h-screen no-scrollbar">
                    {/* <!-- Add margin if you want to see some of the overlay behind the modal--> */}
                    <div className="modal-content py-4 text-left px-2 md:px-5">
                        <div
                            className="modal-close cursor-pointer z-50 float-right"
                            onClick={() => props.onclickhandler()}
                        >
                            <img src={closeIcon} alt="Close" title="Close" />
                        </div>
                        {props.children}
                    </div>
                </div>
            </div>
        </>
    );
}
